import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import WhyNCPro from "../Components/Pages/Home/WhyNCPro";
import BenefitsOfNcpro from "../Components/Pages/Home/BenefitsOfNCPro";
import EmailForm from "../Components/Pages/Home/EmailForm";
import Banner from "../Components/Pages/Home/Banner";
import Introduction from "../Components/Pages/Home/Introduction";
import WhatIsNCPro from "../Components/Pages/Home/WhatIsNCPro";
import AIPoweredFeatures from "../Components/Pages/Home/AIPoweredFeatures";
import AIDrivenRootCause from "../Components/Pages/Home/AIDrivenRootCause";
import NCProSoftware from "../Components/Pages/Home/NCProSoftware";
import Header from "../Components/Common/Header";
import Footer from "../Components/Common/Footer";
import NumberCounter from "../Components/Pages/Home/NumberCounter";

const Home = () => {
  const emailFormRef = useRef(null);
  const navigate = useNavigate();

  const scrollToForm = () => {
    if (emailFormRef.current) {
      emailFormRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <Header />
      <Banner scrollToForm={scrollToForm} navigate={navigate} />
      <Introduction />
      <WhatIsNCPro />
      <WhyNCPro />
      <AIPoweredFeatures />
      <AIDrivenRootCause />
      <BenefitsOfNcpro />
      <NumberCounter />
      <NCProSoftware />
      <EmailForm emailFormRef={emailFormRef} />
      <Footer label="home" />
    </>
  );
};

export default Home;
